/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Tooltip,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import { incidentReport } from "Samarth Module/api/incidentReporting";
import NestedDropdown from "components/common/NestedDropdown/NestedDropdown";

export const CATEGORY_OPTIONS = ["Incident", "Change Request", "New development"];

const SEVERITY_OPTIONS = [
  { value: "P1", label: "P1 - Critical" },
  { value: "P2", label: "P2 - High" },
  { value: "P3", label: "P3 - Medium" },
  { value: "P4", label: "P4 - Low" },
];

export const EPICS_DATA = [
  "RMPM",
  "MD",
  "ORLT",
  "LTCP",
  "QComm",
  "PSO"
]

export const PAGE_DROPDOWN_DATA = [
  {
    label: "Alert Summary",
    children: [{ label: "RMPM Summary", value: "RMPM Summary" }],
  },
  {
    label: "Daily Production Scheduler",
    children: [
      {
        label: "Smart Production Scheduler",
        value: "Smart Production Scheduler",
      },
      { label: "DPR (Plan VS Actual)", value: "DPR (Plan VS Actual)" },
      { label: "Dynamic Prioritization", value: "Dynamic Prioritization" },
      { label: "Daily Phasing insight", value: "Daily Phasing insight" },
    ],
  },
  {
    label: "RMPM shortage epic",
    children: [
      {
        label: "RMPM Autonomous Engine",
        children: [
          { label: "Detailed View", value: "Detailed View" },
          { label: "MAI View", value: "MAI View" },
          { label: "FG Coverage", value: "FG Coverage" },
          { label: "Open PO Details", value: "Open PO Details" },
          { label: "Stock To Norm", value: "Stock To Norm" },
        ],
      },
      {
        label: "Cognitive Contract Coverage",
        children: [
          {
            label: "Contract Coverage - Current Week",
            value: "Contract Coverage - Current Week",
          },
          {
            label: "Contract Coverage - Future Weeks",
            value: "Contract Coverage - Future Weeks",
          },
        ],
      },
      {
        label: "RMPM Analytics",
        value: "RMPM Analytics",
      },
      {
        label: "Supplier Collaboration Agent",
        children: [
          {
            label: "Supplier Collaboration Agent",
            value: "Supplier Collaboration Agent",
          },
          { label: "Monitor Today", value: "Monitor Today" },
          { label: "TnT Linkage", value: "TnT Linkage" },
        ],
      },
    ],
  },
  {
    label: "Manufacturing disruption epic",
    children: [
      { label: "Agile OR", value: "Agile OR" },
      { label: "OR Analytics", value: "OR Analytics" },
      { label: "Manpower Shortage", value: "Manpower Shortage" },
    ],
  },
  {
    label: "FG Stock Out epic",
    children: [
      {
        label: "Order To Delivery Hub",
        children: [
          { label: "Order To Delivery Hub", value: "Order To Delivery Hub" },
          {
            label: "Order Execution Monitor",
            value: "Order Execution Monitor",
          },
        ],
      },
      {
        label: "Loss To Action Engine",
        children: [
          { label: "INTR Recovery", value: "INTR Recovery" },
          {
            label: "Unloading Prioritisation",
            value: "Unloading Prioritisation",
          },
          { label: "In-Transit Recovery", value: "In-Transit Recovery" },
          {
            label: "Dispatch Prioritisation",
            value: "Dispatch Prioritisation",
          },
          { label: "Material view", value: "Material view" },
        ],
      },
    ],
  },
  {
    label: "NR Replenishment Engine",
    children: [
      {
        label: "NR Replenishment Engine",
        children: [
          { label: "Smart Source Length", value: "Smart Source Length" },
          { label: "DC Supply Insights", value: "DC Supply Insights" },
        ],
      },
    ],
  },
  {
    label: "Quick Comm epic",
    children: [
      { label: "Hands Free VL", value: "Hands Free VL" },
      { label: "Dispatch Priority", value: "Dispatch Priority" },
      { label: "PO Priority", value: "PO Priority" },
    ],
  },
   {
    label: "LTCP",
    value: "LTCP",
    children: [],
  },
  // {
  //   label: "External Links",
  //   children: [
  //     { label: "Everstream", value: "Everstream" },
  //     { label: "Grid Eye", value: "Grid Eye" },
  //     { label: "Capacity Master", value: "Capacity Master" },
  //   ],
  // },
  // {
  //   label: "Samarth AI",
  //   children: [{ label: "Samarth AI", value: "Samarth AI" }],
  // },
];

const initialFormData = {
  functionality: "",
  description: "",
  severity: "",
  attachment: [],
  category: "",
  epicName: "",
  pageName: "",
  title: "",
};

export default function IssueReportDialog({ open, onClose, firstName }) {
  const [state, setState] = useState({
    snackbarOpen: false,
    vertical: "top",
    horizontal: "right",
    message: "",
    backgroundColor: "#000",
    textColor: "#fff",
  });
  const [pages, setPages] = useState([]);
  const [userInfo ,setUserInfo] = useState({})
  const { vertical, horizontal, snackbarOpen, backgroundColor, textColor } =
    state;

  const reportDateTime = new Date().toLocaleString();

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false)

  const resetFormData = () => setFormData({ ...initialFormData });
  const handleClose = () => {
    resetFormData();
    onClose();
  };

  
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("UserInfo");
    if (storedUserInfo && JSON.parse(storedUserInfo)) {
      const parsedUserInfo = JSON.parse(storedUserInfo)?.user_info;

      setUserInfo({
        accessType: parsedUserInfo.accessType,
        email: parsedUserInfo.email,
        id: parsedUserInfo.id,
        name: parsedUserInfo.name,
        persona: parsedUserInfo.persona,
        scope: parsedUserInfo.scope,
        scope_value: parsedUserInfo.scope_value ? JSON.parse(parsedUserInfo.scope_value): [],
        userType: parsedUserInfo.userType,
      });
    } else {
      setUserInfo({})
    }
  }, []);

  const validateFileType = (file) => {
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    return allowedTypes.includes(file.type);
  };

  const isSameFile = (fileA, fileB) =>
    fileA.name === fileB.name &&
    fileA.size === fileB.size &&
    fileA.lastModified === fileB.lastModified;

  const addAttachments = (files) => {
    const existing = Array.isArray(formData.attachment)
      ? formData.attachment
      : [];
    const incoming = Array.from(files);

    const uniqueIncoming = incoming.filter(
      (file, index, self) =>
        self.findIndex((item) => isSameFile(item, file)) === index,
    );

    const filtered = uniqueIncoming.filter(
      (file) =>
        validateFileType(file) &&
        !existing.some((existingFile) => isSameFile(existingFile, file)),
    );

    if (!filtered.length) {
      const duplicateFound = uniqueIncoming.some((file) =>
        existing.some((existingFile) => isSameFile(existingFile, file)),
      );
      if (duplicateFound) {
        toastMessage("Duplicate files were skipped.", 2500, {
          backgroundColor: "#333",
          textColor: "#fff",
        });
      }
      return;
    }

    const next = [...existing, ...filtered].slice(0, 5);
    setFormData({ ...formData, attachment: next });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      addAttachments(files);
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const { description, severity, category, title, pageName, epicName } = formData;
    return category === "Incident"
      ? description && severity && title && epicName && category && pageName
      : description && title && category && epicName && pageName;
  };

  const toastMessage = (message, duration = 2500, additional) => {
    setState({
      ...state,
      snackbarOpen: true,
      message: message,
      ...additional,
    });
    setTimeout(() => {
      setState({
        ...state,
        snackbarOpen: false,
        message: "",
        backgroundColor: "#000000",
        textColor: "#fff",
      });
    }, duration);
  };

  const submitIncidentReport = async () => {
    // Handle form submission logic here
    if (!validateForm()) {
      toastMessage("Please fill all the required fields.", 2500, {
        backgroundColor: "var(--high-critical)",
        textColor: "#fff",
      });
      return;
    }

    if (!Array.isArray(formData.attachment) || !formData.attachment.length) {
      // no attachments are optional
    } else {
      const invalidFile = formData.attachment.find(
        (file) => !validateFileType(file),
      );
      if (invalidFile) {
        toastMessage(
          "Invalid file type. Please upload PNG, JPEG, or Excel files.",
          2500,
          { backgroundColor: "var(--low-critical)", textColor: "#fff" },
        );
        return;
      }
    }
    // If form is valid, proceed with submission (e.g., send data to backend)

    const payload = new FormData();
    payload.append("reported_by", firstName);
    payload.append("title", formData.title);
    payload.append("description", formData.description);
    payload.append("severity", formData.severity);
    payload.append("reporter_email", userInfo.email);
    payload.append("reporter_persona", userInfo.persona);
    payload.append("scope_value", userInfo?.scope_value);
    payload.append("scope", userInfo?.scope);
    payload.append("epic_name", formData?.epicName);
    if (Array.isArray(formData.attachment)) {
      formData.attachment.forEach((file) =>
        payload.append("screenshots", file),
      );
    }
    payload.append("category", formData.category);
    payload.append("page_name", formData.pageName);
    payload.append("status", "New");

    try {
      setLoading(true)
      const res = await incidentReport(payload);

      if (res?.ticket_key) {
        toastMessage(
          `Incident reported successfully! Ticket ID: ${res.ticket_key}`,
          4000,
          {
            backgroundColor: "var(--primary-unilever-color)",
            textColor: "#fff",
          },
        );
        // setTimeout(() => {
        onClose();
        resetFormData();
        // }, 4000);
      }
    } catch (error) {
      toastMessage(
        "Error submitting incident report. Please try again later.",
        2500,
        { backgroundColor: "var(--high-critical)", textColor: "#fff" },
      );

      console.error("Error submitting incident report:", error);
    } finally {
      setLoading(false)
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={snackbarOpen}
        message={state.message}
        key={vertical + horizontal}
        slotProps={{
          content: {
            sx: {
              backgroundColor,
              color: textColor,
            },
          },
        }}
      />
      <DialogTitle>SCNC Incident Reporting</DialogTitle>

      <DialogContent
        sx={{
          py: 1.5,
          fontFamily: "Unilever Shilling",
          fontSize: "12px",
          fontWeight: 400,
          "& .MuiInputBase-input, & .MuiInputLabel-root, & .MuiFormLabel-root, & .MuiSelect-select, & .MuiTypography-root, & .MuiMenuItem-root":
            {
              fontFamily: "Unilever Shilling",
              fontSize: "12px",
              fontWeight: 400,
            },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} marginTop={1}>
            {/* ===== ROW 1 ===== */}
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <TextField
                label="User Name"
                value={firstName}
                fullWidth
                disabled
                slotProps={{
                  input: { sx: { height: 56 } },
                }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <TextField
                label="Report Date & Time"
                value={reportDateTime}
                fullWidth
                disabled
                slotProps={{
                  input: { sx: { height: 56 } },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <TextField
                select
                label="Category *"
                name="category"
                value={formData.category}
                onChange={handleChange}
                fullWidth
                slotProps={{
                  input: { sx: { height: 56 } },
                }}
              >
                {CATEGORY_OPTIONS.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    sx={{
                      fontFamily: "Unilever Shilling",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }} >
              <TextField
                select
                label="Epic Name *"
                name="epicName"
                value={formData.epicName}
                onChange={handleChange}
                fullWidth
                slotProps={{
                  input: { sx: { height: 56 } },
                }}
              >
                {EPICS_DATA.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    sx={{ fontFamily: 'Unilever Shilling', fontSize: '12px', fontWeight: 400 }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <NestedDropdown
                items={PAGE_DROPDOWN_DATA}
                title="Page Name*"
                value={formData.pageName}
                onSelect={(item) => {
                  setFormData({ ...formData, pageName: item.value });
                }}
                style={{ width: "100%" }}
                triggerStyle={{ minHeight: 56 }}
                className="incident-form-dropdown"
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
              <TextField
                select
                label="Impact Severity *"
                name="severity"
                value={formData.severity}
                onChange={handleChange}
                fullWidth
                disabled={formData.category !== "Incident"}
                slotProps={{
                  input: { sx: { height: 56 } },
                  inputAdornment: {
                    position: "end",
                    children: (
                      <Tooltip title="P1: Critical | P2: High | P3: Medium | P4: Low">
                        <IconButton edge="end">
                          <InfoOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ),
                  },
                }}
              >
                {SEVERITY_OPTIONS.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      fontFamily: "Unilever Shilling",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* ===== ROW 2 ===== */}
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Title *"
                name="title"
                value={formData.title}
                onChange={handleChange}
                multiline
                minRows={1}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Description *"
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                minRows={4}
                fullWidth
              />
            </Grid>

            {/* ===== ROW 3 ===== */}
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
                Attachment :
              </Typography>

              <Box
                sx={{
                  border: "2px dashed #c4c4c4",
                  borderRadius: 2,
                  minHeight: 100,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  px: 2,
                  py: 1.5,
                  cursor: "default",
                  textAlign: "center",
                  transition:
                    "border-color 0.2s ease, background-color 0.2s ease",
                  "&:hover": {
                    borderColor: "#1f36c7",
                    backgroundColor: "#f5f7ff",
                  },
                  "&:focus-visible": {
                    outline: "2px solid #1f36c7",
                    outlineOffset: "2px",
                  },
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDragEnter={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (e.dataTransfer.files?.length) {
                    addAttachments(e.dataTransfer.files);
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const files = e.clipboardData?.files;
                  if (files?.length) {
                    addAttachments(files);
                    return;
                  }
                  const items = Array.from(e.clipboardData?.items || []);
                  const pastedFiles = items
                    .map((item) => item.getAsFile())
                    .filter(Boolean);
                  if (pastedFiles.length) {
                    addAttachments(pastedFiles);
                  }
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  <UploadFileIcon />
                  Click the button below or drag & drop files
                </Typography>

                <Typography variant="caption" sx={{ color: "#6b6b6b" }}>
                  Or paste files anywhere inside this box (max 5 files)
                </Typography>

                <Box
                  component="label"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                    py: 1,
                    border: "1px solid #cacaca",
                    borderRadius: 1,
                    backgroundColor: "#fafafa",
                    cursor: "pointer",
                    mt: 1,
                    "&:hover": {
                      borderColor: "#1f36c7",
                      backgroundColor: "#f0f6ff",
                    },
                  }}
                >
                  Browse files
                  <input
                    type="file"
                    hidden
                    name="attachment"
                    accept=".png,.jpg,.jpeg,.xlsx,.xls"
                    multiple
                    onChange={handleChange}
                  />
                </Box>

                {Array.isArray(formData.attachment) &&
                  formData.attachment.length > 0 && (
                    <Box
                      sx={{
                        width: "100%",
                        mt: 1,
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {formData.attachment.map((file, index) => (
                        <Box
                          key={`${file.name}-${file.size}-${index}`}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2,
                            py: 1,
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                            backgroundColor: "#f9f9f9",
                            mt: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              mr: 2,
                            }}
                          >
                            {file.name}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setFormData({
                                ...formData,
                                attachment: formData.attachment.filter(
                                  (_, i) => i !== index,
                                ),
                              });
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          disabled={loading}
          onClick={() => {
            resetFormData();
            onClose();
          }}
          sx={{
            color: "#ff7c7d",
            borderColor: "#ff7c7d",
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          loading={loading}
          disabled={loading}
          sx={{
            backgroundColor: "#1f36c7",
          }}
          onClick={submitIncidentReport}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
